import { useRealtimeKitMeeting } from "@cloudflare/realtimekit-react";
import { RtkMeeting } from "@cloudflare/realtimekit-react-ui";

const RealtimeKitMeeting = () => {
  const { meeting } = useRealtimeKitMeeting();

  return (
    <div className="hidoc-realtimekit-container">
      <RtkMeeting mode="fill" meeting={meeting} showSetupScreen={false} />
    </div>
  );
};

export default RealtimeKitMeeting;
